/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./bcStatusIcon.scss');

const deps = [];

module.exports = angular
  .module('bench.ui.bcStatusIcon', deps)

  .directive('blBcStatusIcon', () => ({
    restrict: 'E',
    scope: {
      clientId: '@',
      ledgerId: '@',
      month: '@',
      year: '@',
    },
    bindToController: true,
    template: require('./bcStatusIcon.html'),
    controller: require('./bcStatusIconCtrl.js'),
    controllerAs: 'vm',
  }));
